// extracted by mini-css-extract-plugin
module.exports = {"backTopWrapper":"backToTop_backTopWrapper__5tIJ5","show":"backToTop_show__JTkRC"};